module.exports = __webpack_public_path__ + "static/orion-logo-light-f63b2f6c10e96f4c0c41a69ac8d06220.png";